import { useState, useEffect } from 'react';
import {Space, Row, Button, Table, Divider, message, PageHeader, Statistic, Tag, Card, Col, Avatar} from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import {DeleteOutlined} from '@ant-design/icons';
import EmployeeAdd from './EmployeeAdd';
import EmployeeUpdate from './EmployeeUpdate';
import axios from 'axios';

const EmployeeComponent = () => {

    const [employeeData, setEmployeeData] = useState()
    const [employeeTotal, setEmployeeTotal] = useState([])
    const [employed, setEmployeed] =useState(0)
    const [unemployed, setUnemployeed] =useState(0)

    const fetchEmployee = () => {
        let getEmployee = `${FetchVariable.Heroku}/employee/`
        axios.get(getEmployee)
            .then((res)=>{
                let data =res.data
                setEmployeeData(data)
                setEmployeeTotal(data.length)

                let numOfEmployee = 0
                for (let i =0; i< data.length; i++){
                    if(data[i].EmployeeStatus ===1){
                        numOfEmployee++
                    }
                }
                setEmployeed(numOfEmployee)

                let numOfUnemployee = 0
                for (let i =0; i< data.length; i++){
                    if(data[i].EmployeeStatus ===0){
                        numOfUnemployee++
                    }
                }
                setUnemployeed(numOfUnemployee)

            })
        }
    
    function deleteEmployee (deleteID){
            let apiURL = `${FetchVariable.Heroku}/employee/`+deleteID
            axios.delete(apiURL)
                .then(() => {
                    fetchEmployee()
                    message.error('The Employee is deleted')
                })
    }

    const addEmployee = (addEmployeeData)=>{
            let apiURL = `${FetchVariable.Heroku}/employee/`
            axios.post(apiURL, addEmployeeData)
              .then(res=>{
                    if(res.data.error){
                        let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                        message.error(errorMessage,10);
                    }else{
                        fetchEmployee()
                    }
                }
              ).catch(err=>{console.log(err)})
        }

    const updateEmployee = (updateEmployee)=>{
            let apiURL = `${FetchVariable.Heroku}/employee/`
            axios.put(apiURL, updateEmployee)
              .then(res=>{
                if(res.data.error){
                    let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                    message.error(errorMessage,10);
                }else{
                    fetchEmployee()
                }
            }
          ).catch(err=>{console.log(err)})
        }

    useEffect(() => {
        fetchEmployee();
    }, [])
    
    let emailFilter = []
    employeeData?.forEach((e)=>{emailFilter.push({text:e.EmployeeEmail, value:e.EmployeeEmail})})
        const EmployeeColums = [
        {
            title: 'Employee ID',
            dataIndex: 'EmployeeID',
            key: 'EmployeeID',
            sorter: (a, b) => a.EmployeeID - b.EmployeeID,
            sortDirections: ['descend','ascend'],
        },
        {
            title: 'Employee Photo',
            dataIndex: 'EmployeePhoto',
            key: 'EmployeePhoto',
            render:(record, value)=>{
                if (value.EmployeePhoto === null){
                    return(
                        <p style={{marginBottom:'auto', marginTop:'auto', marginLeft:'7px'}}>N/A</p>
                    )                
                }else {
                    return(
                        <Avatar src={value.EmployeePhoto} alt={value.EmployeePhoto} size={64}/>
                    )
                }
            }

        },
        {
            title: 'Employee Name',
            dataIndex: 'EmployeeName',
            key: 'EmployeeName',
        },
        {
            title: 'Employee Phone',
            dataIndex: 'EmployeePhone',
            key: 'EmployeePhone',
            width:150,
        },
        {
            title: 'Employee Email',
            dataIndex: 'EmployeeEmail',
            key: 'EmployeeEmail',
            filters: emailFilter,
            filterSearch: true,
            onFilter: (value, record) => record.Model.indexOf(value) === 0,
        },
        {
            title: 'Employee Status',
            dataIndex: 'EmployeeStatus',
            key: 'EmployeeStatus',
            filters:[
                {text:'Unemployed', value:0},
                {text:'Employed', value:1},
            ],
            onFilter: (value, record) => (
                record.EmployeeStatus === value 
            ),
            render:(record)=>{
                if (record === 1){return(<Tag  color="success">Employed</Tag>)}
                else if (record === 0){return(<Tag  color="default"> Unemployed</Tag>)}
            },
            sorter: (a, b) => a.EmployeeStatus - b.EmployeeStatus,
            sortDirections: ['descend','ascend'],
        },
       
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
              <Space size="middle">
                <EmployeeUpdate record={record} updateEmployee={updateEmployee}/>
                <Button onClick={()=> deleteEmployee(record.EmployeeID) } type="primary" danger icon={<DeleteOutlined />}></Button>
              </Space>
            ),
          },
    ]

    return(
        <>
            <PageHeader
            className="site-page-header"
            title="Employee Management"
            extra={[ 
                <EmployeeAdd key="addEmployee" addEmployee={addEmployee}/>,
            ]}
            >
                <div className="site-statistic-demo-card">
                    <Row gutter={16}>
                        <Col span={8}>
                            <Card>
                                <Statistic
                                    title="Employee In Total"
                                    value={employeeTotal}
                                />
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card>
                                <Statistic
                                    title="Employed"
                                    value={employed}
                                    valueStyle={{ color: '#3dbd7d' }}
                                />
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card>
                                <Statistic
                                    title="Unemployed"
                                    value={unemployed}
                                    valueStyle={{ color: '#919191' }}

                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
            </PageHeader>

            <Divider />
            <Row>
                <Table columns={EmployeeColums} dataSource={employeeData} rowKey={(record)=>record.EmployeeID} scroll={{ x: 1500, y: 1000 }}/>
            </Row>
        </>
    )
}

export default EmployeeComponent